import { generateQueryParams } from "utils/custom-functions";
import { isUseFilterDefault } from "utils/user";
import fetch from "../utils/fetch";

export const fetchSupplierForMaterialAndUserLoggedGroup = (materialId) => {
  return fetch
    .get(`suppliers:for-current-user?MaterialId=${materialId}`)
    .then(({ data }) => data);
};

export const fetchSupplierByMaterials = (params) => {
  return fetch
    .get(`suppliers:by-materials?${generateQueryParams(params)}`)
    .then(({ data }) => data);
};

export const fetchSupplierForOrder = (orderId) => {
    return fetch.get(`suppliers:by-order?orderId=${orderId}`).then(({ data }) => data)
  };

export const getSuppliersForFilters = () => fetch.get('suppliers:for-filters').then(({ data }) => data)

export const fetchSupplierOrigins = (supplierId) => {
  if (!supplierId) return Promise.resolve([]);

  return fetch
    .get(`/fornecedor/${supplierId}/origins?useFilterDefault=${isUseFilterDefault()}`)
    .then(({ data }) => (data ?? [])
        .map((origin) => ({
          ...origin,
          id: origin.id ?? origin.Id,
          name: origin.name ?? origin.Name ?? origin.Description ?? origin.Descricao,
        }))
      .filter((origin) => origin.id !== undefined && origin.id !== null && String(origin.name ?? "").trim())
    );
};
